import dayjs from 'dayjs';
import React, { useState } from 'react';
import PageTitle from '../../../utils/PageTitle';
import { mkRelativeUrl } from '../../../utils/URL';
import ReportCategoryButton from '../Components/ReportCategoryButton';
import ReportsPageHeader from '../Components/ReportsPageHeader';

function SaleReportPage() {
    const [formData, setFormData] = useState({
        startDate: dayjs().startOf('month').format('YYYY-MM-DD'),
        endDate: dayjs().endOf('month').format('YYYY-MM-DD')
    });

    const summaryPath = mkRelativeUrl('/reports/sales/summary', {
        'start-date': formData?.startDate,
        'end-date': formData?.endDate
    });

    const detailsPath = mkRelativeUrl('/reports/sales/details', {
        'start-date': formData?.startDate,
        'end-date': formData?.endDate
    });

    const applicationWisePath = mkRelativeUrl('/reports/sales/application', {
        'start-date': formData?.startDate,
        'end-date': formData?.endDate
    });

    const customerWisePath = mkRelativeUrl('/reports/sales/customer', {
        'start-date': formData?.startDate,
        'end-date': formData?.endDate
    });

    // set page title
    PageTitle(`Sale Reports`);

    return (
        <div className="inner_page_cont">
            <ReportsPageHeader formData={formData} setFormData={setFormData} />

            <ReportCategoryButton
                summaryPath={summaryPath}
                detailsPath={detailsPath}
                applicationWisePath={applicationWisePath}
                customerWisePath={customerWisePath}
            />
        </div>
    );
}

export default SaleReportPage;
